// extracted by mini-css-extract-plugin
export var btn = "screen1-module--btn--b24b5";
export var screen1 = "screen1-module--screen1--427b9";